
export default function ShallowEquals(objA: any, objB: any) {
    if (objA === objB)
        return true;

    if ((!objA && objB) || (!objB && objA))
        return false;

    if (objA && objB && Object.keys(objA).length !== Object.keys(objB).length)
        return false;

    for (const key in objA) {
        if (objA[key] !== objB[key]) {
            return false
        }
    }

    return true;
}

export const shallowArrayEquals = (arrayA: any[], arrayB: any[]) => {
    const sortedArrayA = arrayA.slice().sort();
    const sortedArrayB = arrayB.slice().sort();
    return sortedArrayA.length === sortedArrayB.length && arrayA.every((objA, ind) => ShallowEquals(objA, sortedArrayB[ind]));
}
